import { render, staticRenderFns } from "./about-sothebys.vue?vue&type=template&id=4ed7f5f0&lang=html&"
import script from "./about-sothebys.vue?vue&type=script&lang=js&"
export * from "./about-sothebys.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports